module.exports = __webpack_public_path__ + "static/fipcsafari1-bd59dad416e333a30609a2fddeb7de12.jpeg";